$(function () {
    $('[data-smoothscroll]').on('click', function (event) {
        event.preventDefault();
        window.scrollTo('#' + $(this).data('smoothscroll'));
    });
    $(window).on('load', function () {
        if (window.location.hash) {
            window.scrollTo(window.location.hash);
        }
    });
});

window.scrollTo = function (targetName) {
    const target = $(targetName);

    if (!target.length) {
        console.log('Smoothscroll kan de volgende module niet vinden:', targetName);
        return;
    }

    let offset = target.offset().top;

    offset -= $('.header').outerHeight();

    $('html, body').animate({
        scrollTop: offset,
    }, 1000);
};
